<template lang="html">
  <v-container>
    <!-- <h2>FILTER.stats</h2>
    <v-row>
      <StandardTextfield :value="stats_filter" @changeValue="updateStatsFilter($event)" textcolor="snow" placeholder="Filter stats..." />
    </v-row> -->
    <!-- v-if="filterStatsArr(getUserStats).length > 0" -->
    <!-- <h2 >TAKT.stats</h2> -->
    <v-row>
      <v-col v-for="(hist_stats, index) in filterStatsArr(getHistUserStats)" :key="'histuser'+index" :cols="getCols()">
        <v-card>
          <h3>{{ hist_stats.label }} </h3>
          <LineChart :height="500" :chart-data="getLineChartData(hist_stats)" />
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(hist_stats, index) in filterStatsArr(getHistProjectStats)" :key="'histproject'+index" :cols="getCols()">
        <v-card>
          <h3>{{ hist_stats.label }} </h3>
          <LineChart :height="500" :chart-data="getProjectLineChartData(hist_stats)" />
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(hist_stats, index) in filterStatsArr(getHistSequenceStats)" :key="'histsequence'+index" :cols="getCols()">
        <v-card>
          <h3>{{ hist_stats.label }} </h3>
          <LineChart :height="500" :chart-data="getSequenceLineChartData(hist_stats)" />
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(hist_stats, index) in filterStatsArr(getHistWorkpackageStats)" :key="'histworkpackage'+index" :cols="getCols()">
        <v-card>
          <h3>{{ hist_stats.label }} </h3>
          <LineChart :height="500" :chart-data="getWorkpackageLineChartData(hist_stats)" />
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(hist_stats, index) in filterStatsArr(getMCallbacksStats)" :key="'histmcallbacks'+index" :cols="getCols()">
        <v-card>
          <h3>{{ hist_stats.label }} </h3>
          <LineChart :height="500" :chart-data="getMCallbackLineChartData(hist_stats)" />
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(hist_stats, index) in filterStatsArr(getMCustomerRequestStats)" :key="'histmcallbacks'+index" :cols="getCols()">
        <v-card>
          <h3>{{ hist_stats.label }} </h3>
          <LineChart :height="500" :chart-data="getMCustomerRequestLineChartData(hist_stats)" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LineChart from '@/components/LineChart.component.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    LineChart,
  },
  name: 'Stats',
  data: function () {
    return {
      stats_filter: '',
      colors: ['#CD5C5C','#FF69B4','#EEE8AA','#D8BFD8','#BA55D3','#6A5ACD',
      '#ADFF2F','#2E8B57','#20B2AA','#4169E1','#DEB887','#B8860B','#F0FFFF']
    };
  },
  computed: {
    ...mapGetters('Stats', [
      'getUserStats',
      'getProjectStats',
      'getWorkbenchStats',
      'getCommunityStats',
      'getHistUserStats',
      'getHistProjectStats',
      'getHistSequenceStats',
      'getHistWorkpackageStats',
      'getMCallbacksStats',
      'getMCustomerRequestStats',
      'isLoading'
    ]),
  },
  methods: {
    updateStatsFilter(stats_filter){
      this.stats_filter = stats_filter;
    },
    filterStatsArr(arr){
      if (arr && arr.length) {
        if (this.stats_filter) {
          return arr.filter( obj => obj.label.includes(this.stats_filter.toUpperCase()));
        }
        return arr;
      }
      return null;
    },
    getChartData(stats_data){
      return {
        labels: stats_data.labels,
        datasets: [{
          label: stats_data.label,
          data: Object.values(stats_data.stats),
          backgroundColor: "#2E8B57",
          strokeColor: "black"
        }]
      };
    },
    getPieChartData(stats_data){
      return {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: stats_data.labels,
        datasets: [
          {
            label: stats_data.label,
            backgroundColor: this.getColors(stats_data.labels.length),
            data: Object.values(stats_data.stats)
          }
        ]
      };
    },
    getLineChartData(stats_data){
      return {
        labels: stats_data.labels,
        datasets: [
          {
            borderColor: "#2E8B57",
            label: 'BASE.user',
            data: stats_data.stats.base
          },
          {
            borderColor: "#DEB887",
            label: 'INVITED.user',
            data: stats_data.stats.invited
          },
          {
            borderColor: "#BA55D3",
            label: 'FULL.user',
            data: stats_data.stats.full
          }
        ]
      };
    },
    getProjectLineChartData(stats_data){
      return {
        labels: stats_data.labels,
        datasets: [
          {
            borderColor: '#CD5C5C',
            label: 'projects',
            data: stats_data.stats.projects
          },
          {
            borderColor: '#FF69B4',
            label: 'trains',
            data: stats_data.stats.trains
          },
          {
            borderColor: '#EEE8AA',
            label: 'taktareas',
            data: stats_data.stats.taktareas
          },
          {
            borderColor: '#D8BFD8',
            label: 'twaggons',
            data: stats_data.stats.twaggons
          },
          {
            borderColor: '#BA55D3',
            label: 'twork_packages',
            data: stats_data.stats.twork_packages
          },
          {
            borderColor: '#6A5ACD',
            label: 'twork_steps',
            data: stats_data.stats.twork_steps
          },
          {
            borderColor: '#ADFF2F',
            label: 'tquality_steps',
            data: stats_data.stats.tquality_steps
          },
          {
            borderColor: '#2E8B57',
            label: 'tdefect_steps',
            data: stats_data.stats.tdefect_steps
          },
          {
            borderColor: '#20B2AA',
            label: 'thandover_steps',
            data: stats_data.stats.thandover_steps
          },
          {
            borderColor: '#4169E1',
            label: 'logentries',
            data: stats_data.stats.logentries
          },
          {
            borderColor: '#DEB887',
            label: 'milestones',
            data: stats_data.stats.milestones
          }
        ]
      };
    },
    getSequenceLineChartData(stats_data){
      return {
        labels: stats_data.labels,
        datasets: [
          {
            borderColor: '#CD5C5C',
            label: 'sequences',
            data: stats_data.stats.sequences
          },
          {
            borderColor: '#FF69B4',
            label: 'swaggons',
            data: stats_data.stats.swaggons
          },
          {
            borderColor: '#EEE8AA',
            label: 'swork_packages',
            data: stats_data.stats.swork_packages
          },
          {
            borderColor: '#D8BFD8',
            label: 'swork_steps',
            data: stats_data.stats.swork_steps
          },
          {
            borderColor: '#BA55D3',
            label: 'squality_steps',
            data: stats_data.stats.squality_steps
          },
          {
            borderColor: '#6A5ACD',
            label: 'sdefect_steps',
            data: stats_data.stats.sdefect_steps
          },
          {
            borderColor: '#ADFF2F',
            label: 'shandover_steps',
            data: stats_data.stats.shandover_steps
          },
          {
            borderColor: '#2E8B57',
            label: 'slogistic_steps',
            data: stats_data.stats.slogistic_steps
          },
          {
            borderColor: '#20B2AA',
            label: 'sdesign_steps',
            data: stats_data.stats.sdesign_steps
          },
          {
            borderColor: '#DEB887',
            label: 'smilestones',
            data: stats_data.stats.smilestones
          }
        ]
      };
    },
    getWorkpackageLineChartData(stats_data){
      return {
        labels: stats_data.labels,
        datasets: [
          {
            borderColor: '#CD5C5C',
            label: 'work_packages',
            data: stats_data.stats.work_packages
          },
          {
            borderColor: '#FF69B4',
            label: 'wwork_steps',
            data: stats_data.stats.wwork_steps
          },
          {
            borderColor: '#EEE8AA',
            label: 'wquality_steps',
            data: stats_data.stats.wquality_steps
          },
          {
            borderColor: '#D8BFD8',
            label: 'wdefect_steps',
            data: stats_data.stats.wdefect_steps
          },
          {
            borderColor: '#BA55D3',
            label: 'whandover_steps',
            data: stats_data.stats.whandover_steps
          },
          {
            borderColor: '#6A5ACD',
            label: 'wlogistic_steps',
            data: stats_data.stats.wlogistic_steps
          },
          {
            borderColor: '#ADFF2F',
            label: 'wdesign_steps',
            data: stats_data.stats.wdesign_steps
          }
        ]
      };
    },
    getMCustomerRequestLineChartData(stats_data){
      if (stats_data.label === 'CODE.mcustomerrequests') {
        return {
          labels: stats_data.labels,
          datasets: [
            {
              borderColor: '#ADFF2F',
              label: 'ok',
              data: stats_data.stats.ok
            },
            {
              borderColor: '#FF69B4',
              label: 'created',
              data: stats_data.stats.created
            },
            {
              borderColor: '#EEE8AA',
              label: 'okay_empty',
              data: stats_data.stats.okay_empty
            },
            {
              borderColor: '#D8BFD8',
              label: 'bad_request',
              data: stats_data.stats.bad_request
            },
            {
              borderColor: '#BA55D3',
              label: 'forbidden',
              data: stats_data.stats.forbidden
            },
            {
              borderColor: '#6A5ACD',
              label: 'not_found',
              data: stats_data.stats.not_found
            },
            {
              borderColor: '#CD5C5C',
              label: 'conflict',
              data: stats_data.stats.conflict
            }
          ]
        };
      } else {
        return {
          labels: stats_data.labels,
          datasets: [
            {
              borderColor: '#ADFF2F',
              label: 'get',
              data: stats_data.stats.get
            },
            {
              borderColor: '#6A5ACD',
              label: 'put',
              data: stats_data.stats.put
            },
            {
              borderColor: '#EEE8AA',
              label: 'post',
              data: stats_data.stats.post
            },
            {
              borderColor: '#CD5C5C',
              label: 'delete',
              data: stats_data.stats.delete
            }
          ]
        };
      }
    },
    getMCallbackLineChartData(stats_data){
      if (stats_data.label === 'ENTITY.mcallbacks') {
        return {
          labels: stats_data.labels,
          datasets: [
            {
              borderColor: '#CD5C5C',
              label: 'train',
              data: stats_data.stats.train
            },
            {
              borderColor: '#FF69B4',
              label: 'taktarea',
              data: stats_data.stats.taktarea
            },
            {
              borderColor: '#EEE8AA',
              label: 'wagon',
              data: stats_data.stats.wagon
            },
            {
              borderColor: '#D8BFD8',
              label: 'workpackage',
              data: stats_data.stats.workpackage
            },
            {
              borderColor: '#BA55D3',
              label: 'workstep',
              data: stats_data.stats.workstep
            },
            {
              borderColor: '#6A5ACD',
              label: 'defectstep',
              data: stats_data.stats.defectstep
            },
            {
              borderColor: '#ADFF2F',
              label: 'qualitystep',
              data: stats_data.stats.qualitystep
            },
            {
              borderColor: '#ADFF2F',
              label: 'logisticstep',
              data: stats_data.stats.logisticstep
            },
            {
              borderColor: '#ADFF2F',
              label: 'handoverstep',
              data: stats_data.stats.handoverstep
            },
            {
              borderColor: '#ADFF2F',
              label: 'designstep',
              data: stats_data.stats.designstep
            }
          ]
        };
      }
      if (stats_data.label === 'METHOD.mcallbacks') {
        return {
          labels: stats_data.labels,
          datasets: [
            {
              borderColor: '#FF69B4',
              label: 'post',
              data: stats_data.stats.post
            },
            {
              borderColor: '#EEE8AA',
              label: 'put',
              data: stats_data.stats.put
            },
            {
              borderColor: '#D8BFD8',
              label: 'delete',
              data: stats_data.stats.delete
            }
          ]
        };
      }
    },
    getColors(amount){
      return this.colors.slice(0, amount);
    },
    getTotal(stats){
      return Object.values(stats).reduce((a, b) => a + b, 0);
    },
    getCols(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 12;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 6;
      } else {
        return 4;
      }
    },
  }

}
</script>

<style lang="scss" scoped>
</style>
